import { Brain, Mic, Repeat, Sparkles } from "lucide-react";
import { MEDIA } from "@/lib/constants";

const pillars = [
    {
        icon: Brain,
        title: "Active Recall",
        desc: "Treine o cérebro a buscar a palavra, não só reconhecê-la.",
    },
    {
        icon: Repeat,
        title: "Chunking",
        desc: "Aprenda em blocos prontos, do jeito que nativos pensam.",
    },
    {
        icon: Mic,
        title: "Shadowing",
        desc: "Imite áudios reais. Em semanas, sua boca aprende inglês.",
    },
    {
        icon: Sparkles,
        title: "Imersão Inteligente",
        desc: "Filmes, podcasts e ferramentas certas — 30 min por dia bastam.",
    },
];

export default function Solution() {
    return (
        <section
            id="solution"
            data-testid="section-solution"
            className="bg-cream py-24 lg:py-32"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                    <div className="lg:col-span-5 reveal relative">
                        <div className="relative rounded-[2rem] overflow-hidden shadow-2xl">
                            <img
                                src={MEDIA.travelPhoto}
                                alt="Andrei em Londres, na frente do Big Ben"
                                className="w-full h-[520px] object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-emerald-brand/50 via-transparent to-transparent" />
                        </div>
                        <div className="absolute -bottom-6 -right-4 sm:-right-8 bg-white border border-cream rounded-2xl p-5 shadow-xl max-w-[220px]">
                            <p className="label-eyebrow">Inglês na vida real</p>
                            <p className="mt-2 font-serif text-2xl text-emerald-brand leading-tight">
                                Londres, sem medo de <em>falar</em>.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-7 reveal">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="hairline w-10" />
                            <span className="label-eyebrow">A solução</span>
                        </div>
                        <h2 className="font-serif text-emerald-brand text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight">
                            O método que poliglotas usam para{" "}
                            <span className="italic text-gold-brand">
                                aprender 7 idiomas
                            </span>
                            . Agora adaptado para você destravar
                            <span className="italic"> um</span>: o inglês.
                        </h2>
                        <p className="mt-6 text-lg text-emerald-light/90 leading-relaxed">
                            Esqueça apostila, gramática chata e listas
                            infinitas. O método junta as 4 técnicas que
                            realmente funcionam — comprovadas por linguistas e
                            usadas por quem fala 5, 6, 7 idiomas com naturalidade.
                        </p>

                        <div className="mt-10 grid sm:grid-cols-2 gap-4">
                            {pillars.map((p, i) => {
                                const Icon = p.icon;
                                return (
                                    <div
                                        key={i}
                                        className="bg-white border border-cream rounded-2xl p-5 hover:border-gold-brand transition-colors"
                                        data-testid={`pillar-${i}`}
                                    >
                                        <div className="w-10 h-10 rounded-xl bg-emerald-brand flex items-center justify-center mb-3">
                                            <Icon className="w-5 h-5 text-gold-brand" />
                                        </div>
                                        <h3 className="font-serif text-emerald-brand text-xl">
                                            {p.title}
                                        </h3>
                                        <p className="mt-1 text-sm text-emerald-light/85 leading-snug">
                                            {p.desc}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
